var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"dual-img"},_vm._l((_vm.content[0].field_dual_image),function(image,index){return _c('img',{key:index,attrs:{"src":image.url,"alt":index}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }